const ko = {
    scanAddSuccess: '스캔 순서가 성공적으로 추가되었습니다',
    scanAddFail: '스캔 순서 추가에 실패했습니다',
    tip: '팁',
    delScanTip1: '이 스캔을 삭제하시겠습니까? 삭제 후에는 데이터를 복구할 수 없습니다',
    scanDelSuccess: '스캔 순서가 성공적으로 삭제되었습니다',
    addScan: '새로운 스캔 목록 추가',
    scanCount: '총 {{count}}개의 항목이 스캔되었습니다',
    oprtName: '운영자: {{name}}',
    enterCode: '바코드를 입력하세요',
    cancel: '취소',
    confirm: '확인',
    sameCheck: '복제 확인',
    conIn: '저장 확인',
    conOut: '배달 확인',
    addScanTip: "기본적으로 데이터는 '공백'과 '엔터'로 구분되며, 입력이 완료되면 반복되는 바코드는 삭제됩니다.",
    scanSheet1: '스캔 시트 1',
    sameBarcodeTip1: '동일한 제품에 중복된 바코드가 있습니다. 데이터를 수정하여 다시 제출하세요. ',
    sameBarcodeTip2: '스캔한 양식에 중복된 바코드가 있습니다. 데이터를 확인하고 다시 제출하세요. ',
    confirmClearData: '현재 페이지에는 이미 콘텐츠가 있습니다. 데이터를 지우시겠습니까? ',
    scanSheetNum: '시트 {{num}} 스캔',
    scanSheetCount: '시트 {{count}}개를 스캔하세요',
    fillBarcodeFirst: '바코드를 먼저 입력한 후 데이터를 추가하세요. ',
    selProductForBarcode: '제품:',
    selProductForBarcodePl: '바코드에 맞는 제품을 선택하세요',
    clear: '클리어',
    addNew: '추가',
    scanSheetData: '스캔 시트 데이터',
    addScanMax: '최대 {{num}}개의 스캔 주문만 추가할 수 있습니다',
    scanNumExceedMax: '바코드 개수가 최대 한도를 초과했습니다',
    scanNumExceedMaxTip: '최대 {{num}}개의 바코드를 입력할 수 있습니다. ',
    residualBarcodeNum: '{{residueNum}}개의 바코드를 추가할 수 있습니다. 데이터를 수정하고 다시 제출하세요.',
    confirmDelBarcodesNum: '선택한 {{delNum}}개 바코드를 삭제하시겠습니까?',
    delText: '삭제',
    saveText: '저장',
    saveAndAdd: '저장 및 추가',
    addBarcodes: '바코드 추가',
    delBarcodes: '바코드 삭제',
    notFoundBarcodes: '바코드를 찾을 수 없습니다',
    confirmClearDataTip: '현재 페이지에 저장되지 않은 콘텐츠가 있습니다. 삭제하시겠습니까? ',
    searchBarcodePlaceholder: '검색할 바코드를 입력하세요',
    notSelectedBarcode: '바코드가 현재 선택되지 않았습니다',
    noDelScanSheet: '데이터가 하나만 남은 경우, 이는 기본 데이터이며 삭제할 수 없습니다. ',
    butDelTooltip: '현재 제품 및 바코드 데이터 지우기',
    butSaveTooltip: '현재 스캔 데이터 저장',
    butSaveAndAddTooltip: '스캔 순서 데이터 저장 및 새 스캔 순서 추가',
    manufactureBarcode: '바코드 일괄 생성',
    barcodeNotEmpty: '바코드 데이터는 비어 있을 수 없습니다',
    saveScanTip: '먼저 현재 스캔을 저장하세요',
    barcodePrefix: '바코드 접두사',
    barcodeSuffix: '바코드 접미사',
    barcodeStartNum: '바코드 시작 번호',
    barcodeEndNum: '바코드 종료 번호',
    barcodeMaxCount: '생성되는 항목의 최대 개수({{maxCount}}개 항목)',
    generateBarcode: '바코드 생성',
    scanDataFillTip: '기존 스캔 데이터를 입력해 주세요',
    allCheckBarcodes: '모두 선택',
    endLessThanStart: '종료 번호는 시작 번호보다 작을 수 없습니다',
    selectProductTip: '제품을 선택해주세요',
    barcodeTip: '바코드를 입력해주세요',
    productAndBarcodeTip: '제품을 선택하시고 바코드를 입력해주세요',
    delInInventory: '재고 삭제 및 확인',
    delOutInventory: '재고 삭제 및 품절 확인',
    selectPl: '선택해주세요',
};

export default ko;